import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { batch, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Icon } from '../../../components/Icon';
import { Modal } from '../../../components/Modal';
import { useAppRoutes } from '../../../hooks/useAppRoutes';
import { useCustomerState } from '../../Briefing/CustomerState';

export const CustomerSelectionBar: FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isModalHidden, setIsModalHidden] = useState(true);
  const [
    { cpCustomer, cpCustomerUser, isSelectionConfirmed },
    { setCPCustomer, setCPCustomerUser, setIsSelectionConfirmed },
  ] = useCustomerState();
  const { briefingSelectionRoute } = useAppRoutes();

  const onChangeCustomerUser = () => {
    setIsModalHidden(false);
  };

  const onConfirm = () => {
    setIsModalHidden(true);
    batch(() => {
      dispatch(setCPCustomer(null));
      dispatch(setCPCustomerUser(null));
      dispatch(setIsSelectionConfirmed(false));
    });
    navigate(briefingSelectionRoute);
  };

  const onCancel = () => {
    setIsModalHidden(true);
  };

  return (
    <>
      <div
        className={`${
          isSelectionConfirmed ? '' : 'hidden'
        } sticky top-0 left-0 z-10`}
      >
        <div className="w-full bg-blue-400 text-white flex items-center justify-between px-3 md:px-6 py-3 text-xs z-10">
          <div className="flex items-center ml-1 md:ml-0">
            <div className="mr-1 w-6">
              <Icon name="AccountBehalf" inline={true} />
            </div>
            <div data-testid="customer-info">
              <span className="hidden mr-1 md:inline">{`${t(
                'components:customerSelectionBar:onBehalf',
              )}`}</span>
              {cpCustomer || cpCustomerUser
                ? `${cpCustomer?.name} (${cpCustomer?.marketCountryName}) / ${cpCustomerUser?.firstName} ${cpCustomerUser?.lastName}`
                : 'Unknown'}
            </div>
          </div>
          <div
            className="flex flex-shrink-0 ml-4 cursor-pointer"
            onClick={onChangeCustomerUser}
            data-testid="customer-change"
          >
            <span className="w-4 mr-1">
              <Icon name="Edit" inline={true} />
            </span>
            <span>{t('modals:changeCustomerSelection:change')} </span>
          </div>
        </div>
      </div>
      <Modal
        icon="AccountBehalf"
        heading={t('modals:changeCustomerSelection:prompt')}
        isHidden={isModalHidden}
        confirmText={t('modals:changeCustomerSelection:confirm')}
        cancelText={t('modals:changeCustomerSelection:cancel')}
        onConfirm={onConfirm}
        onCancel={onCancel}
      >
        {t('modals:cancelBriefing:content')}
      </Modal>
    </>
  );
};
